// initial state
// shape: [{ id, quantity }]
const state = {
  sessionStr: '',
  sessionUserId: '',
  userInfo: {},
  userName:'',
  set sessionInfo(val) {
    if (val === '') {
      sessionStorage.clear();
      return;
    }
    let {
      mobile,
      pwd,
      token,
      userModel,
      ResultModel,
      isLogin,
    } = val;
    sessionStorage.setItem('mobile', mobile);
    sessionStorage.setItem('pwd', pwd);
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("ResultModel", ResultModel);
    sessionStorage.setItem('userModel', userModel);
    sessionStorage.setItem('isLogin', isLogin);
  },
  get sessionInfo() {
    let sessionInfo = {};
    // if (!sessionStorage.getItem('isLogin')) {
    //   sessionStorage.setItem('isLogin', false);
    // }
    sessionInfo.mobile = sessionStorage.getItem('mobile');
    sessionInfo.pwd = sessionStorage.getItem('pwd');
    sessionInfo.token = sessionStorage.getItem('token');
    sessionInfo.ResultModel = sessionStorage.getItem('ResultModel');
    sessionInfo.userModel = sessionStorage.getItem('userModel');
    sessionInfo.isLogin = sessionStorage.getItem('isLogin');
    return sessionInfo;
  },
  set userCerStatus(val){
    sessionStorage.setItem('userCerStatus', val);
  },
  get userCerStatus(){
    return sessionStorage.getItem('userCerStatus');
  },
  // 当session
  get UserToken() {
    return sessionStorage.getItem('token')
  },
  set UserToken(value) {
    sessionStorage.setItem('token', value)
  },
}

// getters
const getters = {
  sessionInfoGetter: (state)  => state.sessionInfo,
  userInfoGetter: (state) => state.userInfo,
  userCerStatusGetter:(state)=>state.userCerStatus,
  userNameGetter: (state) => state.userName
}

// actions
const actions = {

}

// mutations
const mutations = {
  setUserInfo(state, value) {
    state.userInfo=value;   
  },
  setSessionInfo: function (state, val) {
    state.sessionInfo = val;
  },
  setUserName(state,value){
    state.userName = value
  },
  LOGIN_IN(state, data) {
    state.UserName = data[0]
    state.UserToken = data[1]
  },
  LOGIN_OUT(state) {
    state.UserName = ''
    state.UserToken = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js